// Structured Data for SEO
export const organizationStructuredData = {
  "@context": "https://schema.org",
  "@type": "EducationalOrganization",
  "name": "TeachWithDuke",
  "description": "Personalized programming education platform offering 1-on-1 mentorship in Python, React, DevOps, Machine Learning, and Data Analysis.",
  "url": "https://teachwithduke.vercel.app",
  "logo": "https://teachwithduke.vercel.app/logo.png",
  "image": "https://teachwithduke.vercel.app/og-image.jpg",
  "telephone": "+1-234-567-890",
  "email": "duke@teachwithduke.vercel.app",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "Global",
    "addressLocality": "Online"
  },
  "sameAs": [
    "https://linkedin.com/in/duke-nyamongo-74a043178/",
    "https://github.com/dukelester",
    "https://twitter.com/teachwithduke",
    "https://youtube.com/@teachwithduke"
  ],
  "founder": {
    "@type": "Person",
    "name": "Duke",
    "jobTitle": "Software Engineer & Educator",
    "description": "Experienced software engineer with 7+ years of teaching experience, helping students worldwide transition into tech careers."
  },
  "offers": {
    "@type": "Offer",
    "description": "Personalized programming courses and mentorship",
    "priceRange": "$45-80",
    "priceCurrency": "USD"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "500",
    "bestRating": "5",
    "worstRating": "1"
  }
};

export const localBusinessStructuredData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "TeachWithDuke",
  "description": "Premium 1-on-1 programming mentorship for Python, React, DevOps, Machine Learning, and Data Analysis.",
  "url": "https://teachwithduke.vercel.app",
  "image": "https://teachwithduke.vercel.app/og-image.jpg",
  "telephone": "+254745711132",
  "email": "teachwithduke@gmail.com",
  "priceRange": "$$",
  "areaServed": "Worldwide",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "KE"
  },
  "sameAs": [
    "https://linkedin.com/in/duke-nyamongo-74a043178/",
    "https://github.com/dukelester",
    "https://twitter.com/teachwithduke",
    "https://youtube.com/@teachwithduke"
  ]
};

export const professionalServiceStructuredData = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": "TeachWithDuke",
  "url": "https://teachwithduke.vercel.app",
  "description": "Professional programming tutoring and coaching services delivered in live one-on-one sessions.",
  "serviceType": [
    "Python tutoring",
    "React mentorship",
    "DevOps coaching",
    "Machine learning tutoring",
    "Data analysis coaching",
    "Interview preparation"
  ],
  "provider": {
    "@type": "Person",
    "name": "Duke",
    "jobTitle": "Software Engineer & Programming Mentor"
  },
  "areaServed": "Worldwide",
  "availableLanguage": ["English"],
  "offers": {
    "@type": "OfferCatalog",
    "name": "1-on-1 Programming Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Python Tutor Sessions"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "React Mentor Sessions"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "DevOps Coaching Sessions"
        }
      }
    ]
  }
};

export const courseStructuredData = (course) => ({
  "@context": "https://schema.org",
  "@type": "Course",
  "name": course.title,
  "description": course.description,
  "provider": {
    "@type": "EducationalOrganization",
    "name": "TeachWithDuke",
    "url": "https://teachwithduke.vercel.app"
  },
  "instructor": {
    "@type": "Person",
    "name": "Duke",
    "jobTitle": "Software Engineer & Educator"
  },
  "courseMode": "online",
  "educationalLevel": course.level,
  "timeRequired": course.duration,
  "offers": {
    "@type": "Offer",
    "price": (course.price.match(/\d+(\.\d+)?/) || ["0"])[0],
    "priceCurrency": "USD",
    "availability": "https://schema.org/InStock"
  },
  "teaches": course.topics,
  "coursePrerequisites": "Basic computer skills",
  "educationalCredentialAwarded": "Certificate of Completion"
});

export const faqStructuredData = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const breadcrumbStructuredData = (breadcrumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": crumb.name,
    "item": `https://teachwithduke.vercel.app${crumb.url}`
  }))
});

export const personStructuredData = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Duke",
  "jobTitle": "Software Engineer & Educator",
  "description": "Experienced software engineer and educator specializing in Python, React, DevOps, Machine Learning, and Data Analysis. Helping students worldwide transition into tech careers through personalized 1-on-1 mentorship.",
  "url": "https://teachwithduke.vercel.app/about",
  "image": "https://teachwithduke.vercel.app/duke-profile.jpg",
  "sameAs": [
    "https://linkedin.com/in/duke-nyamongo-74a043178/",
    "https://github.com/dukelester",
    "https://twitter.com/teachwithduke",
    "https://youtube.com/@teachwithduke"
  ],
  "knowsAbout": [
    "Python Programming",
    "React Development",
    "DevOps",
    "Machine Learning",
    "Data Analysis",
    "Web Development",
    "Software Engineering",
    "Career Guidance"
  ],
  "alumniOf": "Software Engineering",
  "worksFor": {
    "@type": "EducationalOrganization",
    "name": "TeachWithDuke"
  }
};

export const reviewStructuredData = (reviews) => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "TeachWithDuke",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": reviews.length,
    "bestRating": "5",
    "worstRating": "1"
  },
  "review": reviews.map(review => ({
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": review.rating,
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": review.name
    },
    "reviewBody": review.content,
    "datePublished": new Date().toISOString()
  }))
});
